import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '@/App';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import InfusionMonitor from '@/components/InfusionMonitor';

const InfusionMonitorPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [infusion, setInfusion] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchInfusion();
    // Auto-refresh every 5 seconds
    const interval = setInterval(fetchInfusion, 5000);
    return () => clearInterval(interval);
  }, [id]);

  const fetchInfusion = async () => {
    try {
      const response = await axios.get(`${API}/infusions/${id}`);
      setInfusion(response.data);
    } catch (error) {
      console.error('Error fetching infusion:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!infusion) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <p className="text-gray-600 mb-4">Perfusion non trouvée</p>
          <Button onClick={() => navigate('/infusions')}>
            <ArrowLeft className="w-4 h-4 mr-2" />
            Retour aux perfusions
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <InfusionMonitor
        open={true}
        onClose={() => navigate('/infusions')}
        infusion={infusion}
        onUpdate={fetchInfusion}
      />
    </div>
  );
};

export default InfusionMonitorPage;
